import React, { Component } from 'react';
import { connect } from 'react-redux';
// constant
// utils
import { Translations, convertStringToArray } from '../../../utils';
// rest client
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import ReactTable from '../AdminPanel/SubComp/Grid/Table/';
import ResetPassword from './ResetPassword';
// action creator
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
import { setAdminTabIndex } from '../actions/actionCreator';
//style
import '../AdminPanel/SubComp/Grid/Table/index.css';
import './CustomerDetail.css';

class CustomerDetail extends Component {
  state = {
    displayUserData: [],
    pageJson: undefined,
    deleteCustomerModalJson: undefined,
    showCustomerDeleteModal: false,
    showResetPasswordModal: false,
    showRevokeCustomerDeleteModal: false,
    customerId: undefined,
    customerName: this.props.customer.fullName,
    customerEmail: this.props.customer.email,
    customerData: this.props.customer
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  componentDidMount() {
    this.props.setDarkTitleBarTitle(this.props.customer.fullName);

    eapiClient('/cases/customer-mail-data?emailId=' + this.props.customer.email)
      .then(({ data }) => {
        let secondaryMailIds = data.responseData.map(x => { return x.secondaryMailIds });
        let mails = [];
        for (let index = 0; index < secondaryMailIds.length; index++) {
          let arrData = secondaryMailIds[index];
          for (let i = 0; i < arrData.length; i++) {
            mails.push({ "email": arrData[i] });
          }
        }
        let mailData = [...data.responseData, ...mails];
        const unique = [];
        mailData.map(x => unique.filter(a => a.email == x.email).length > 0 ? null : unique.push(x));
        this.setState({
          userDataReset: unique
        })
      });

  }

  componentWillMount() {

    eapiClient('/cases/customerCases?emailId=' + this.state.customerEmail)
      .then(({ data }) => {
        this.setState({
          displayUserData: data.responseData
        })
      });

    // Dark Title Bar
    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${Translations(data.par.static_text_darkTitleBar.groupMember, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
      });

    //Customer Detail
    aemHostClient("/aemData/formData/json_customer-detail")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });

    // Delecte Customer Admin page json for Modal - Revoke Confirmation
    aemHostClient("/aemData/formData/json_revoke-action-confirmation")
      .then(({ data }) => {
        this.setState({ deleteRevokeConfirmationModalJson: data.par });
      });

    // Delete Customer Admin page json for Modal - Delete Customer
    aemHostClient("/aemData/formData/json_delete-customer")
      .then(({ data }) => {
        this.setState({ deleteCustomerModalJson: data.par });
      });

    //Reset password

    aemHostClient("/aemData/formData/json_reset-password-admin")
      .then(({ data }) => {
        this.setState({ resetPasswordModalJson: data.par });
      });

  }

  getUpdateData = () => {
    eapiClient('/cases/customerCases?emailId=' + this.state.customerEmail)
      .then(({ data }) => {
        this.setState({
          displayUserData: data.responseData
        })
      });
  }

  // Final payload
  submit = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state);
    eapiClient("/customers/", {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setAdminTabIndex(2);
        this.props.history.push('/admin-panel/')
      });
  }

  // Delete Customer
  deleteCustomerData = () => {
    let payload = new DeleteCustomerPayload();
    payload.setPayload(this.state);

    eapiClient(`/customers?email=${payload.data.email}`, {
      method: 'DELETE',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setAdminTabIndex(2);
        this.props.history.push('/admin-panel/')
      });

    this.toggleCustomerDialog();
  }

  deleteCustomer = () => {
    this.setState({
      showCustomerDeleteModal: true
    })
  }
  resetPasswordPop = () => {
    this.setState({
      showResetPasswordModal: true
    })
  }
  setUsermail = (event) => {
    const emailId = { to: event.target.value, value: event.target.value };
    let filterCustomerSecondaryOwner = this.state.userDataReset.filter(item => item.email === event.target.value);
    this.setState({
      ...this.state.emailId,
      emailId,
      filterCustomerSecondaryOwner
    });
  }
  // ReseT Password
  resetPassword = (event) => {
    //Temperory open modal to reset Password
    let payload = new ResetPasswordPayload();
    payload.setPayload(this.state);
    this.setState({
      showResetPasswordModal: false,
      emailId: {}
    })
    eapiClient("/customers/resetPassword", {
      method: 'POST',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setAdminTabIndex(2);
        //this.props.history.push('/admin-panel/')
      })
  }

  columnsHeader = () => {
    let optionData;
    var options = this.translations(this.state.pageJson.table_caseAccess.fieldLabels);
    var ids = this.state.pageJson.table_caseAccess.fields;
    optionData = convertStringToArray(options)
    let columns = []
    ids.map((item, index) => {
      columns.push({
        accessor: item,
        Header: optionData[index],
        sortable: false
      })
    })
    return columns;
  }

  getInputValue = (e) => {
    this.setState({
      customerName: e.target.value
    })
  }

  toggleCustomerDialog = () => {
    this.setState({
      showCustomerDeleteModal: false,
      showRevokeCustomerDeleteModal: false
    })
  }
  toggleResetpasswordDialog = (val) => {
    this.setState({
      showResetPasswordModal: val
    })
  }

  openRevokeModal = (data) => {
    this.setState({
      showRevokeCustomerDeleteModal: true,
      customerId: data.id,
      customerEmail: this.props.customer.email
    })
  }

  revokeAccess = () => {
    let payload = new RevokeAccessPayload();
    payload.setPayload(this.state);
    eapiClient("/cases/revokeUserAccess/", {
      method: 'POST',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.getUpdateData()
        this.props.setAdminTabIndex(2);
      })
    this.toggleCustomerDialog();
  }

  render() {
    const { customerName } = this.state
    return (this.state.pageJson !== undefined && this.state.resetPasswordModalJson !== undefined && this.state.deleteCustomerModalJson !== undefined && this.state.deleteRevokeConfirmationModalJson !== undefined ? (
      <div className="customer-detail">
        <div className="customer-detail--section">
          <label className="group-lbl">{this.translations(this.state.pageJson.text_box_customerName.title)}</label>
          <input type="text" value={customerName} onChange={this.getInputValue} />
        </div>

        <div className="customer-detail--section">
          <label className="group-lbl">{this.translations(this.state.pageJson.text_box_email.title)}</label>
          <span>{this.state.customerEmail}</span>
        </div>
        <div className="customer-detail--section customer-detail--border-none">
          <div className="gdoc-customer-tab-tab-content gdoc-tab-tab-content">
            <h2 className="gdocs-mtop-5 gdocs-mbottom-15">{this.translations(this.state.pageJson.table_caseAccess.text)}</h2>
            <ReactTable
              data={this.state.displayUserData}
              columns={this.columnsHeader()}
              noLink={(data) => this.openRevokeModal(data)}
              lang={this.props.lang}
              pageJsonContent={this.state.pageJson.table_caseAccess}
            />
          </div>
        </div>
        <div className="gdocs-clear-float"></div>
        <div className="customer-detail--submit-section">
          <div className="form-buttons-wrapper">
            <button aria-label="Add account" className="gdocs-btn-delete" onClick={this.deleteCustomer}>
              {this.translations(this.state.pageJson.button_deleteCustomer.text)}
            </button>

            <button aria-label="Add account" className="gdocs-btn-reset gdocs-mleft-30" onClick={this.resetPasswordPop}>
              {this.translations(this.state.pageJson.button_resetPassword.text)}
            </button>

            <ResetPassword
              showResetPasswordModal={this.state.showResetPasswordModal}
              setToggleResetpasswordDialog={this.toggleResetpasswordDialog}
              resetPassword={this.resetPassword}
              userDataReset={this.state.userDataReset}
              setUsermail={this.setUsermail}
              _value={this.state.emailId !== undefined ? this.state.emailId.to : ""}
              pageJson={this.state.resetPasswordModalJson}
              translations={(word) => this.translations(word)} />

            <Modal
              show={this.state.showCustomerDeleteModal}
              onClose={this.toggleCustomerDialog}
              bsClass="delete-group-model"
            >
              <ModalHeader title={this.translations(this.state.deleteCustomerModalJson.page_title_mainTitle.pageHeading)} />
              <ModalBody>
                {this.translations(this.state.deleteCustomerModalJson.page_title_mainTitle.descriptionText)}
                <br /> <br />
                {this.translations(this.state.deleteCustomerModalJson.page_title_mainTitle.staticText)}
              </ModalBody>
              <ModalFooter>
                <div className="delete-group-model--body">
                  <div className="gdocs-float-left">
                    <button className="gdocs-btn-delete" onClick={this.toggleCustomerDialog}>
                      {this.translations(this.state.deleteCustomerModalJson.button_doNotDelete.text)}
                    </button>
                  </div>
                  <div className="gdocs-float-right">
                    <button className="gdocs-btn-primary" onClick={this.deleteCustomerData}>
                      {this.translations(this.state.deleteCustomerModalJson.button_deleteCustomer.text)}
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Modal>

            <Modal
              show={this.state.showRevokeCustomerDeleteModal}
              onClose={this.toggleCustomerDialog}
              bsClass="delete-group-model"
            >
              <ModalHeader title={this.translations(this.state.deleteRevokeConfirmationModalJson.page_title_mainTitle.pageHeading)} />
              <ModalBody>
                {this.translations(this.state.deleteRevokeConfirmationModalJson.page_title_mainTitle.descriptionText)}
                <br /> <br />
                {this.translations(this.state.deleteRevokeConfirmationModalJson.page_title_mainTitle.staticText)}
              </ModalBody>
              <ModalFooter>
                <div className="delete-group-model--body">
                  <div className="gdocs-float-left">
                    <button className="gdocs-btn-delete" onClick={this.toggleCustomerDialog}>
                      {this.translations(this.state.deleteRevokeConfirmationModalJson.button_doNotRevoke.text)}
                    </button>
                  </div>
                  <div className="gdocs-float-right">
                    <button className="gdocs-btn-primary" onClick={this.revokeAccess}>
                      {this.translations(this.state.deleteRevokeConfirmationModalJson.button_revokeAccess.text)}
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Modal>

            <button aria-label="Add account" className="gdocs-btn-submit" onClick={this.submit}>
              {this.translations(this.state.pageJson.button_done.text)}
            </button>
          </div>
        </div>
      </div>
    ) : '');
  }
}

class DeleteCustomerPayload {
  constructor() {
    this.data = {}
  }
  setPayload({ customerEmail }) {
    this.data = {
      email: customerEmail
    }
  }
}

class ResetPasswordPayload {
  constructor() {
    this.data = {}
  }

  setPayload({ customerData, customerName, emailId, filterCustomerSecondaryOwner }) {
    this.data = {
      fullName: customerName,
      to: emailId.to,
      secondaryMailIds: filterCustomerSecondaryOwner[0].secondaryMailIds,
      ...customerData
    }
  }
}

// Delete Revoke Entity (Delete Button Payload)
class RevokeAccessPayload {
  constructor() {
    this.data = {}
  }
  setPayload({ customerEmail, customerId }) {
    var cust = []
    cust.push(customerEmail)
    this.data = [
      {
        caseId: customerId,
        userIds: cust
      }
    ]
  }
}

// Final Done button payload
class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayload({ customerName, customerEmail }) {
    //var userData = displayUserData.map(item => item.id)
    this.data = {
      fullName: customerName,
      email: customerEmail
    };
  }
}

const mapStateToProps = state => {
  return {
    customer: state.customerAdmin,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarTitle: pageTitle => {
      dispatch(setDarkTitleBarContent(pageTitle))
    },
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetail)



// WEBPACK FOOTER //
// ./src/components/Admin/CustomerDetail/CustomerDetail.js